const messages = {
  title: '¡Ups! Parece que hubo un error',
  subTitle: 'Si tienes dudas, escribenos a ',
  email: 'notifications@mymoons.mx',
  tryAgain: 'INTENTAR DE NUEVO',
}

export default messages
